import ajax from '@/libs/api.request'
 export default {
  //获取学生列表
   list:param=>{
     return ajax.post('edu/web/student/list',param);
   },
   //获取学生详情
   getStudentDetail:param=>{
     return ajax.post('edu/web/student/getStudentDetail',param);
   },
   //保存学生基本信息
   saveDetail:param=>{
     return ajax.post('edu/web/student/saveStudentDetail',param);
   },
   //获取家长列表
   getParentsList:param=>{
     return ajax.post('edu/web/student/getParentsList',param);
   },
   //删除家长信息
   delParent:param=>{
     return ajax.post('edu/web/student/delParent',param);
   },
   //保存家长信息
   saveParent:param=>{
     return ajax.post('edu/web/student/saveParent',param);
   },
   //获取课程信息
   getCourseList:param=>{
     return ajax.post('edu/web/student/getCourseList',param);
   },
   //获取课程具体安排时间
   getCourseTime:param=>{
     return ajax.post('/edu/web/student/getCourseTime',param);
   },
   //获取已买课程
   getHavingCourse:param=>{
     return ajax.post('edu/web/student/getHavingCourse',param);
   },
   getScheduleDetail:param=>{
     return ajax.post('edu/web/student/getScheduleDetail',param);
   },
   getScheduleTime:param=>{
     return ajax.post('edu/web/student/getScheduleTime',param);
   },
   getTeacher:param=>{
     return ajax.post('edu/web/student/getTeacher',param);
   },
   saveSchedule:param=>{
     return ajax.post('edu/web/student/saveSchedule',param);
   },
   getClassList:param=>{
     return ajax.post('edu/web/student/getClassListS',param);
   },
   getPayList:param=>{
     return ajax.post('edu/web/student/getPayList',param);
   },
   savePay:param=>{
     return ajax.post('edu/web/student/savePay',param);
   },
   getLog:param=>{
     return ajax.post('edu/web/student/getLog',param);
   },
   getTeacherCoursesList:param=>{
     return ajax.post('edu/web/student/getTeacherCoursesList',param);
   },
   getTeacherCoursesTime:param=>{
     return ajax.get('edu/web/student/getTeacherCoursesTime');
   },
   getclassrest:param=>{
     return ajax.post('edu/web/student/getclassrest',param);
   },
   getDateFormat: e => {
     let currentDate = null
     if (e != '' && e != null && e.length != 10) {
       let month = e.getMonth() + 1
       let day = e.getDate()
       if (month >= 1 && month <= 9) {
         month = '0' + month
       }
       if (day >= 0 && day <= 9) {
         day = '0' + day
       }
       currentDate = e.getFullYear()+'-'+ month+'-' + day
     } else {
       currentDate = e
     }
     return currentDate
   },
   delStudent:param=>{
     return ajax.post('edu/web/student/delStudent',param);
   },
   finish:param=>{
     return ajax.post('edu/web/student/finish',param);
   },
   changeZone:param=>{
     return ajax.post('edu/web/student/changeZone',param);
   },
   doImport:param=>{
     return ajax.post('edu/web/student/doImport',param);
   },
   getNotEnoughClassNumStudentList:param=>{
     return ajax.post('edu/web/student/getNotEnoughClassNumStudentList',param);
   },
   getBeOverplusStudentList:param=>{
     return ajax.post('edu/web/student/getBeOverplusStudentList',param);
   },
   getStudentClassBuyList:param=>{
     return ajax.post('edu/web/student/getStudentClassBuyList',param);
   },
   getClassBuyRecordList:param=>{
     return ajax.post('edu/web/student/getClassBuyRecordList',param);
   },
   getFinRecordList:param=>{
     return ajax.post('edu/web/student/getFinRecordList',param);
   },
   transferClassHour:param=>{
     return ajax.post('edu/web/student/transferClassHour',param);
   },
   changeClassHourNum:param=>{
     return ajax.post('edu/web/student/changeClassHourNum',param);
   },
   finishClass:param=>{
     return ajax.post('edu/web/student/finishClass',param);
   },
 }
